import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as InfoIcon } from '../../../assets/svg/InfoIcon.svg'
import CheckedCheckbox from './components/CheckedCheckbox'
import Autocomplete from './components/Autocomplete'
import InfoButton from '../../common/InfoButton'

export const alertRecipients = [
    { label: 'teacher', code: 'teacher' },
    { label: 'headOfYear', code: 'head_of_year' },
    { label: 'counselor', code: 'counsellor' },
]

const EmailSection = ({ settings, save, emails = [] }) => {
    const { t } = useTranslation()
    const [selectedKeywordOptions, setSelectedKeywordOptions] = useState(settings?.email?.keywordsDetected ?? {})
    const [selectedEmotionOptions, setSelectedEmotionOptions] = useState(settings?.email?.multipleNegativeEmotions ?? {})
    const [keywordSelectedEmails, setKeywordSelectedEmails] = useState(settings?.email?.keywordsDetected?.custom ?? [])
    const [undesirableSelectedEmails, setUndesirableSelectedEmails] = useState(settings?.email?.multipleNegativeEmotions?.custom ?? [])

    useEffect(() => {
        if (!!settings) {
            setKeywordSelectedEmails(settings?.email?.keywordsDetected?.custom ?? [])
            setUndesirableSelectedEmails(settings?.email?.multipleNegativeEmotions?.custom ?? [])
            setSelectedKeywordOptions(settings?.email?.keywordsDetected ?? {})
            setSelectedEmotionOptions(settings?.email?.multipleNegativeEmotions ?? {})
        }
    }, [settings])

    const handleSelection = (type, field) => {
        const data = {
            ...settings,
            email: {
                ...settings.email,
                [field]: {
                    ...settings.email[field],
                    [type]: !settings.email[field][type],
                },
            },
        }
        save(data)
        if (field === 'keywordsDetected') {
            setSelectedKeywordOptions(data?.email?.keywordsDetected ?? {})
        } else if (field === 'multipleNegativeEmotions') {
            setSelectedEmotionOptions(data?.email?.multipleNegativeEmotions ?? {})
        }
    }

    const onSelect = (value, field) => {
        const data = {
            ...settings,
            email: {
                ...settings.email,
                [field]: {
                    ...settings.email[field],
                    custom: value,
                },
            },
        }
        save(data)
        if (field === 'keywordsDetected') setKeywordSelectedEmails(value)
        else if (field === 'multipleNegativeEmotions') setUndesirableSelectedEmails(value)
    }

    return (
        <div className="rounded-[10px] w-full h-full p-[32px] bg-white">
            <div>
                <div className="flex flex-row justify-between">
                    <p className="font-bold text-[24px] leading-[30px] text-darkenPurple">{t('Email notifications')}</p>
                    <InfoButton text={t('Manage who receives email notifications for different types of alerts triggered by student check-ins')} />
                </div>
                <p className="text-darkenPurple font-medium text-[16px] leading-5 mt-[12px] max-w-[50%]">
                    {t('Here you can manage who will receive the email notifications for different types of alerts')}
                </p>
            </div>
            <div className="flex flex-row justify-between">
                <div className="mt-[34px] max-w-[50%] w-full">
                    <div className="flex flex-row gap-[10px]">
                        <p className="font-bold text-darkenPurple">{t('Keyword alerts receipient(s) email')}</p>
                        <InfoButton text={t('Choose who should receive emails when a student uses flagged keywords in their check-in comments')} />
                    </div>
                    {alertRecipients.map((option, index) => (
                        <div key={index} className="flex flex-row items-center mt-[24px] gap-[20px]">
                            <CheckedCheckbox
                                checked={selectedKeywordOptions[option.code]}
                                text={t(option.label)}
                                onClick={() => handleSelection(option.code, 'keywordsDetected')}
                            />
                        </div>
                    ))}

                    <div className="flex flex-row items-center mt-[24px] gap-[20px]">
                        <CheckedCheckbox checked={!!keywordSelectedEmails.length} text={t('Custom email')} disabled />
                    </div>
                    <div className="pl-[40px] pr-[72px]">
                        <Autocomplete options={emails} selectedOptions={keywordSelectedEmails} onSelect={(value) => onSelect(value, 'keywordsDetected')} />
                    </div>
                </div>
                <div className="max-w-[50%] mt-[34px] flex-1">
                    <div className="flex flex-row justify-between items-center gap-[10px]">
                        <p className="font-bold text-darkenPurple">{t('Uncomfortable emotions receipient(s) email')}</p>
                        <InfoButton text={t('Select who gets notified when a student selects uncomfortable emotions over multiple consecutive check-ins')} />
                    </div>
                    {alertRecipients.map((option, index) => (
                        <div key={index} className="flex flex-row items-center mt-[24px] gap-[20px]">
                            <CheckedCheckbox
                                checked={selectedEmotionOptions[option.code]}
                                text={t(option.label)}
                                onClick={() => handleSelection(option.code, 'multipleNegativeEmotions')}
                            />
                        </div>
                    ))}

                    <div className="flex flex-row items-center mt-[24px] gap-[20px]">
                        <CheckedCheckbox checked={!!undesirableSelectedEmails.length} text={t('Custom email')} disabled />
                    </div>
                    <div className="pl-[40px] pr-[72px]">
                        <Autocomplete options={emails} selectedOptions={undesirableSelectedEmails} onSelect={(value) => onSelect(value, 'multipleNegativeEmotions')} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EmailSection
